/**
 * Visibilidad del bloque de frases del día en Resumen e Inspiración.
 */
export function debeMostrarFrasesDelDia(datos) {
  if (!datos || datos.todasLeidas) return false;
  return Array.isArray(datos.frases) && datos.frases.length > 0;
}
